import styled from 'styled-components';

export const StyledIsOpenWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
`;
